import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Drawer, Button, List, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { makeRequest } from "../apis/makeRequest";
import { getCustomer, getTipologias } from "../apis/backendRequests";
import { cartActions, galleryActions } from "../actions";
import { useNavigate, useLocation } from "react-router-dom";
import { DrawertItems } from "./DrawerItems";

const theme = createTheme({
  palette: {
    mode: "dark",
  },
});

const styles = {
  button: {
    backgroundColor: "white",
    color: "black",
    maxWidth: "216px",
  },
  icon: {
    color: "black",
    marginRight: ".25em",
  },
  paper: {
    width: "20em",
    backgroundColor: "#225533",
  },
  listDrawer: {
    "&::-webkit-scrollbar": {
      width: "0.5em",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "transparent",
    },
    scrollbarWidth: "thin",
    scrollbarColor: "transparent transparent",
    overflowY: "auto",
  },
};

export default function DrawerTipologia(props) {
  const { className, ...rest } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dataCategories, setDataCategories] = useState([]);
  const [tabs, setTabs] = useState({ nameTabs: [], categories: [] });

  const { brand } = useSelector((state) => state.gallery);
  const { dynamicsId } = useSelector((state) => state.account);
  const { webOrderId } = useSelector((state) => state.cart);

  const allStr = "Todas";

  useEffect(() => {
    makeRequest(
      () => getCustomer(dynamicsId),
      (res) => {
        if (res.data.priceLevel) {
          makeRequest(
            () => getTipologias(res.data.priceLevel),
            (request) => { Object.keys(request.data).length > 0 && setDataCategories([{ name: allStr }, ...request.data]) },
            null,
            { checkEmptyResults: false }
          );
        }
      }
    );
  }, [brand, dynamicsId]);

  useEffect(() => {
    if (Object.keys(dataCategories).length !== 0) {
      const tab = dataCategories.reduce((ac, categoria) => {
        if (typeof categoria.categoriaDescription !== "undefined") {
          const tipo = categoria.categoriaDescription;
          if (!ac.hasOwnProperty(tipo)) {
            ac[tipo] = {};
          }
          const rubro = categoria.rubroDescription;

          if (!ac[tipo].hasOwnProperty(rubro)) {
            ac[tipo][rubro] = [];
          }
          ac[tipo][rubro].push(categoria);
        }
        return ac;
      }, {});

      const categoryNames = ["Todos los productos", ...Object.keys(tab)].map(
        (label) => ({ label })
      );
      setTabs({ nameTabs: categoryNames, categories: tab });
    }
  }, [dataCategories]);

  const changeCategoria = (categoria = "", rubro = "", subRubro = "") => {
    dispatch(galleryActions.setSearchTerm(""));
    dispatch(galleryActions.setCategoria(categoria));
    dispatch(galleryActions.setRubro(rubro));
    dispatch(galleryActions.setSubRubro(subRubro));
    dispatch(galleryActions.setPromocion(""));
    if (location.pathname !== "/") {
      if (webOrderId !== null) dispatch(cartActions.clear());
      navigate("/");
    }
  };

  return (
    <>
      <Button
        size="small"
        style={`${styles.button} ${className}`}
        variant="text"
        onClick={() => setDrawerOpen(true)}
        disabled={Object.keys(dataCategories).length === 0}
        {...rest}
      >
        <MenuIcon style={styles.icon} fontSize="large" />
        <Typography noWrap color="black">
          Búsqueda por categorías
        </Typography>
      </Button>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Drawer
            anchor="left"
            elevation={1}
            open={drawerOpen}
            sx={styles.listDrawer}
            onClose={(e, reason) => setDrawerOpen(false)}
            PaperProps={{ style: styles.paper }}
            ModalProps={{
              slotProps: {
                backdrop: {
                  invisible: true,
                },
              },
            }}
          >
            <List sx={styles.listDrawer}>
              {tabs.nameTabs.map((tab, i) => {
                return (
                  <DrawertItems
                    label={tab.label}
                    key={tab.label}
                    setCategorias={changeCategoria}
                    categorias={tabs.categories}
                    setDrawerOpen={setDrawerOpen}
                  />
                );
              })}
            </List>
          </Drawer>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
